import { ComponentChildren } from 'preact'
import { Container } from 'semantic-ui-react'
import { Link } from '../index'
import css from './index.module.css'

export const SignupLink = ({ children }: { children: ComponentChildren }) => {
  return (
    <div className={css.fixed}>
      <Container text fluid textAlign="center" className={css.signUpFont}>
        <Link
          href="https://ssl.scandit.com/customers/new?p=test&source=websdk"
          target="_blank"
          rel="noopener"
          style={{ color: 'white' }}
        >
          {children}
        </Link>
      </Container>
    </div>
  )
}
